export default ({ request }) => ({
  ecomAmzFlipOrderSkuPassedApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/passed',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderSkuRejectedApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/sku/rejected',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderPurchaseApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/purchase',
      method: 'POST',
      data,
    })
  },
  ecomAmzFlipOrderCancelPurchaseApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/cancelPurchase',
      method: 'POST',
      data,
    })
  },
})
